<template>
	<div>
		<az-toolbar>
			<template #actions>
				<botao-primario
					nome-botao="Novo"
					icone="add_circle"
					v-az-auth="permissoes.revisoesCriar"
					@click="novaRevisao"
				></botao-primario>
			</template>
			<template #simpleSearch>
				<az-search
					:filter="filtro"
					simple-search-placeholder="Buscar por revisão, atividade ou perfil"
					@simple-search="buscarRevisoesListagemPorFiltro"
					@remove-filter="removerFiltros"
					v-az-auth="permissoes.revisoesListar"
					ref="componenteAzSearch"
					@clear="limparBuscaListagemPorFiltro"
				></az-search>
			</template>
		</az-toolbar>
		<az-container class="listagem">
			<revisoes-listagem
				:revisoes="revisoesDatasource"
				:total-paginas="totalPaginasListagem"
				:total-itens="totalItensListagem"
				:paginacao="paginacaoListagem"
				@paginar="setPaginacaoRevisoesListagem"
				@resetar-page="resetarPaginaRevisoesListagem"
				@recarregar-listagem-revisoes="carregarRevisoesListagem"
			></revisoes-listagem>
		</az-container>
	</div>
</template>

<script>
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import { actionTypes, mutationTypes, routesNames } from '@/core/constants'
import Paginacao from '@/core/store/default/paginacaoListagem'
import RevisoesListagem from '@/views/pages/configuracao/revisoes/listagem/RevisoesListagem.vue'

export default {
	name: 'revisoes',
	components: { RevisoesListagem, BotaoPrimario },
	data() {
		return {
			revisoesDatasource: [],
			totalPaginasListagem: 0,
			totalItensListagem: 0,
			paginacaoListagem: Paginacao(['dataCriacao'], 25, 'DESC'),
		}
	},
	computed: {
		filtro: {
			get() {
				return this.$store.state.configuracao.revisoes.filtro
			},
			set() {
				this.$store.commit(mutationTypes.CONFIGURACAO.REVISOES.SET_FILTRO_LISTAGEM)
			},
		},
	},
	async mounted() {
		await this.carregarRevisoesListagem()
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.CONFIGURACAO.REVISOES.RESET_FILTRO_LISTAGEM)
	},
	methods: {
		async carregarRevisoesListagem() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.CONFIGURACAO.REVISOES.BUSCAR_REVISOES,
			)

			this.revisoesDatasource = itens
			this.totalPaginasListagem = totalPages
			this.totalItensListagem = totalElements
		},
		async buscarRevisoesListagemPorFiltro(searchText) {
			if (searchText) this.filtro.conteudo.value = searchText.trim()

			this.resetarPaginaRevisoesListagem()
			await this.carregarRevisoesListagem()
		},
		async removerFiltros(propriedade) {
			if (this.filtro[propriedade]) {
				this.filtro[propriedade].value = this.filtro[propriedade].default
			}
			await this.carregarRevisoesListagem()
		},
		limparBuscaListagemPorFiltro() {
			this.$store.commit(mutationTypes.CONFIGURACAO.REVISOES.RESET_FILTRO_LISTAGEM)
		},
		setPaginacaoRevisoesListagem(paginacao) {
			this.$store.commit(mutationTypes.CONFIGURACAO.REVISOES.SET_PAGINACAO_LISTAGEM, paginacao)
			this.carregarRevisoesListagem()
		},
		resetarPaginaRevisoesListagem() {
			this.$store.commit(mutationTypes.CONFIGURACAO.REVISOES.RESET_PAGINACAO_LISTAGEM)
		},
		novaRevisao() {
			this.$router.push({ name: routesNames.CONFIGURACAO.REVISOES.REVISOES_CRIACAO_VIEW })
		},
	},
}
</script>
